import { useEffect } from 'react';

import type { UseProductCategoriesEffectsProps } from '@app/pages/Warehouses/ProductCategories/types';

export const useProductCategoriesEffects = ({
  onSearchHandler,
}: UseProductCategoriesEffectsProps) => {
  useEffect(() => {
    onSearchHandler();
  }, [onSearchHandler]);
};
